import Emitter from "./emmiter";
import Listener from "./listener";
import Mixin from "./mixin";
import Logger from "./logger";
import SocketIO from "socket.io-client";
import ss from 'socket.io-stream';
import uid from 'uid';
export default class Xcontact {


    constructor({ config, vuex, debug }) {
        Logger.debug = debug;
        this.io = this.connect(config.connection);
        let socket = this.io;
        this.io.on('connect', () => {
            Logger.info('Conectou', config.user);
            socket.emit('authentication', JSON.stringify({
                xcontactID: config.clientID,
                id: socket.id,
                token: "teste",
                nome: config.user.fullname,
                ativo: 1,
                ramal: config.user.ramal,
                versao: '2.0'
            }));
        })


        this.emitter = new Emitter(vuex);
        this.listener = new Listener(socket, this.emitter, config.user);
    }
    sendMessage(data) {
        this.io.emit('message', JSON.stringify(data));
    }

    sendMessageFile(data) {
        try {
            var stream = ss.createStream();
            var file = data.file[0];
            console.log(`file`, file)
            let aux = file.name.split(`.`);
            let newName = aux[0] + uid();
            data.dados.filename = newName + `.` + aux[1];
            console.log(data.dados.filename);
            if (file.type == '') {
                console.log(`ENTROU AQUIIII`);
                data.dados.type = "application/octet-stream"
            } else {
                data.dados.type = file.type;
            }
            ss(this.io).emit('file', stream, data.dados);
            var size = 0;
            //let readStream = fs.createReadStream(file.path).pipe(stream);
            var blobStream = ss.createBlobReadStream(file);
            blobStream.on('data', (chunk) => {
                size += chunk.length;
                let percent = Math.floor(size / file.size * 100);
                this.emitter.emit('uploadStatus', percent)
                // -> e.g. '42%'
            });
            blobStream.on('end', () => {
                this.emitter.emit('uploadStatus', 0)
                // -> e.g. '42%'
            });
            blobStream.pipe(stream);


        } catch (error) {
            console.error(error);
        }



    }
    async sendMessageFileEmail(data) {
        try {

            for (let file of data.file) {
                let promise = await new Promise((resolve, reject) => {
                    var stream = ss.createStream();
                    let aux = file.name.split(`.`);
                    let newName = aux[0];
                    data.dados.filename = newName + `.` + aux[1];
                    data.filename = data.dados.filename;
                    data.dados.type = file.type;
                    ss(this.io).emit('fileOnly', stream, data.dados);
                    var size = 0;
                    var blobStream = ss.createBlobReadStream(file);
                    blobStream.on('data', (chunk) => {
                        size += chunk.length;
                        let percent = Math.floor(size / file.size * 100);
                        this.emitter.emit('uploadStatus', percent)
                    });
                    blobStream.on('end', () => {
                        this.emitter.emit('uploadStatus', 0)
                        resolve();
                    });
                    blobStream.pipe(stream);
                })


            }
            console.log(`PASSOU POR TUDO`)
            data.dados.file = true;
            data.dados.action = "ClientChatMessage"
            this.io.emit('message', data.dados);



        } catch (error) {
            console.error(error);
        }



    }
    disconnect() {
        this.io = undefined;
        this.emitter.emit('disconnectConfig');
    }


    /**
   * registering SocketIO instance
   * @param connection
   * @param options
   */
    connect(connection) {
        if (connection && typeof connection === "object") {
            Logger.info(`Received socket.io-client instance`);
            return connection;
        } else if (typeof connection === "string") {
            const io = SocketIO(connection, { transports: ['websocket'], upgrade: false });
            Logger.info(`Received connection string`, io);
            return (this.io = io);
        } else {
            throw new Error("Unsupported connection type");
        }
    }

    /**
 * Vue.js entry point
 * @param Vue
 */
    install(Vue) {
        Vue.prototype.$Xcontact = this;
        Vue.mixin(Mixin);
        Logger.info('Xcontact plugin enabled');
    }
}

